import Button from '@mui/material/Button';
import { useDispatch, useSelector } from 'react-redux';
import { bindActionCreators } from 'redux';
import { useCornTechnologies, useSoyTechnologies } from '/@/hooks/catalog';
import { _ } from '/@/locale';
import { setTechnology as setTechnologyAction } from '/@/store/catalog/actions';
import { getSessionCountry } from '/@/store/session/selectors';
import type { Brand } from '/@/types/catalog';
import styles from './styles.module.css';

const NewTechnologyList = ({ type, onClick, brand }: { type: string; onClick: () => void; brand: Brand }) => {
    const dispatch = useDispatch();
    const technologiesCornQuery = useCornTechnologies({ page: 1, pageSize: 10000 });
    const technologiesSoyQuery = useSoyTechnologies({ page: 1, pageSize: 10000 });
    const technologies = (
        (type === 'corn' ? technologiesCornQuery.data?.results : technologiesSoyQuery.data?.results) || []
    ).filter((t) => t.displayInCatalog);

    const setTechnology = bindActionCreators(setTechnologyAction, dispatch);
    const country = useSelector(getSessionCountry);

    const handleGoToCatalog = (id) => {
        setTechnology(id);
        onClick();
    };

    return (
        <div className={styles.root}>
            <div className={styles.technologies}>
                {technologies.map((tech) => {
                    const showIconWarning =
                        (tech.name === 'VTPRO4' || tech.name === 'VTPRO4-RIB') && country.code === 'AR';
                    return (
                        <div key={tech.id} className={styles.technology}>
                            {tech.logoImage && (
                                <div className={styles.logoContainer}>
                                    <div
                                        className={styles.logo}
                                        style={{ backgroundImage: `url('${tech.logoImage}')` }}
                                    />
                                </div>
                            )}
                            {showIconWarning && (
                                <div className={styles.iconWarning}>
                                    <i className={'material-icons'}>info</i>
                                </div>
                            )}
                            <img
                                className={styles.image}
                                src={tech.images.find((i) => i.brand === brand.id)?.image}
                                alt=''
                            />
                            <Button size='small' variant='contained' onClick={() => handleGoToCatalog(tech.id)}>
                                {_('Ver más')}
                            </Button>
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default NewTechnologyList;
